import React from 'react'

function AcccionAdmin() {

  return  <> 
  
  </>;
}

export default AcccionAdmin;